import Button from "../../../components/Button/Button";
import "./FamousPage.css";
import fam1 from "../../../assets/img/fam01.png";
import MobileImg1 from "../../../assets/img/fam_mobile_img(1).png";
import fam2 from "../../../assets/img/Fam2.png";
import fam3 from "../../../assets/img/fam3.png";
import fam4 from "../../../assets/img/fam4.png";
import fam5 from "../../../assets/img/fam5.png";
import { Tile } from "../../../components/Tile/Tile";
import { useNavigate } from "react-router-dom";

function FamousPage() {
  const navigate = useNavigate();
  return (
    <>
      <div className="famous-page">
        <div className="main row my-5 mx-0">
          {/* LEFT - desktop only */}
          <div className="Left col-6 d-none d-md-flex justify-content-end">
            <div className="sub-left">
              <div className="bg-midnight p-5 d-flex h-100 flex-column justify-content-between gap-3 famHead">
                <div>
                  <h1 className="heading font-500-44 line-height-120">
                    Own the conversation. Monetize the moment.
                  </h1>
                  <p className="content font-500-30">
                    Offer the most exclusive fan experience—where only one fan
                    at a time can interact with you directly.
                  </p>
                </div>
                <div className="w-100">
                  <Button
                    variant="primary"
                    className="fan-button p-3"
                    onClick={() => window.open("https://fan1.us/register", "_blank", "noopener,noreferrer")}
                    label={"Register to Offer a Membership"}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT - image section */}
          <div className="col-md-6 p-0 m-0 position-relative">
            <img src={fam1} className="fan-img1 d-none d-md-block" alt="" />
            <img
              src={MobileImg1}
              className="fan-img1 d-block d-md-none"
              alt=""
            />

            {/* Mobile text overlay */}
            <div className="text-overlay d-flex d-md-none flex-column px-4 justify-content-end">
              <div>
                <div className="heading font-500-44 text-white my-4">
                  Own the conversation. Monetize the moment.
                </div>
                <p className="content font-500-20 text-white mb-4">
                  Offer the most exclusive fan experience—where only one fan at
                  a time can interact with you directly.
                </p>
              </div>

              <Button
                variant="primary"
                className="mt-5 fan-button p-3 mb-4"
                onClick={() => window.open("https://fan1.us/register", "_blank", "noopener,noreferrer")}
                label={"Register to Offer a Membership"}
              />
            </div>
          </div>
        </div>

        <div className="container">
          <div className="fam-div-2 mt-80 bg-midnight position-relative overflow-hidden">
            <h2 className="font-500-36 fan-head1">What is Fan1?</h2>
            <h3 className="text-light-purple mb-5 font-500-26 fan-head4">
              Fan1 is the platform where public figures offer a singularly
              exclusive opportunity for fans to become their one-and-only Fan1.
              Through a blind auction, the highest bidder wins a unique,
              time-limited one-on-one interaction with you. Your engagement
              level is entirely up to you.
            </h3>
            <h3 className="font-500-26 fan-head4">Key Features:</h3>
            <ul className="px-4">
              <li>
                <div className="pb-2">
                  <span className="font-inter-700-15">
                    You control the conversation
                  </span>
                  <span className="font-inter-300-15">
                    {" "}
                    – Skip endless DMs. Only one Fan1 at a time, no
                    distractions.
                  </span>
                </div>
              </li>
              <li>
                <div className="pb-2">
                  <span className="font-inter-700-15">
                    Monetize your downtime
                  </span>
                  <span className="font-inter-300-15">
                    {" "}
                    – Earn from your most dedicated fans while setting your own
                    level of engagement.
                  </span>
                </div>
              </li>
              <li>
                <div className="pb-2">
                  <span className="font-inter-700-15">Boost your brand </span>
                  <span className="font-inter-300-15">
                    {" "}
                    – Highly visible, one-on-one conversations show your
                    authentic self to the world.{" "}
                  </span>
                </div>
              </li>
              <li>
                <div>
                  <span className="font-inter-700-15">
                    Climb the global rankings
                  </span>
                  <span className="font-inter-300-15">
                    {" "}
                    – Higher bids put you at the top of the Fan1 leaderboard.
                  </span>
                </div>
              </li>
            </ul>
            <div className="fan-internal-ellipse"></div>
          </div>

          <div className="fam-div-2 mt-80 bg-midnight position-relative">
            <h2 className="font-500-36 fan-head1">Why join Fan1?</h2>
            <div className="fam-row mt-3">
              <div className="column-3 position-relative">
                <h3 className="mb-4 font-500-26 fan-head4">
                  You own the conversation
                </h3>
                <p className="font-inter-300-15">
                  Engage authentically with your biggest fan. No spam, no
                  distractions—just one genuine, exclusive connection at a time.
                </p>
              </div>
              <div className="column-3 position-relative">
                <h3 className="mb-4 font-500-26 fan-head4">
                  Monetize your downtime
                </h3>
                <p className="font-inter-300-15">
                  Fan1 turns your most dedicated fans into an exclusive revenue
                  stream. Whether you engage a little or a lot is up to you.
                </p>
              </div>
              <div className="column-3 position-relative">
                <h3 className="mb-4 font-500-26 fan-head4">
                  Build your brand & influence
                </h3>
                <p className="font-inter-300-15">
                  Your Fan1 interactions are highly observable. You exchange
                  messages with one fan while the whole world can watch. Your
                  name will be listed in global rankings alongside the highest
                  bids, amplifying your brand’s visibility.
                </p>
              </div>
            </div>
            <div className="static-ellipse-left"></div>
          </div>

          <div className="fam-div-3 mt-80 bg-midnight position-relative">
            <h2 className="font-500-36 fan-head1">How It Works?</h2>
            <div className="fam-row mt-3">
              <div className="column-3 position-relative">
                <svg
                  width="26"
                  height="27"
                  viewBox="0 0 26 27"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.9336 17.1094C11.6289 17.4141 11.0703 17.4141 10.7656 17.1094L7.92188 14.2656C7.61719 13.9609 7.61719 13.4023 7.92188 13.0977C8.22656 12.793 8.78516 12.793 9.08984 13.0977L11.375 15.3828L16.4531 10.2539C16.7578 9.94922 17.3164 9.94922 17.6211 10.2539C17.9258 10.5586 17.9258 11.1172 17.6211 11.4219L11.9336 17.1094ZM17.418 2.58594C19.0938 2.28125 20.8711 2.78906 22.1914 4.05859C23.4609 5.37891 23.9688 7.15625 23.6641 8.83203C25.0352 9.79688 26 11.4219 26 13.25C26 15.1289 25.0352 16.7031 23.6641 17.7188C23.9688 19.3945 23.4609 21.1719 22.1914 22.4414C20.8711 23.7617 19.0938 24.2695 17.418 23.9648C16.4531 25.3359 14.8281 26.25 13 26.25C11.1211 26.25 9.49609 25.3359 8.53125 23.9648C6.85547 24.2695 5.07812 23.7617 3.75781 22.4414C2.48828 21.1719 1.98047 19.3945 2.28516 17.7188C0.914062 16.7031 0 15.1289 0 13.25C0 11.4219 0.914062 9.79688 2.28516 8.83203C1.98047 7.15625 2.48828 5.37891 3.75781 4.05859C5.07812 2.78906 6.85547 2.28125 8.53125 2.58594C9.49609 1.21484 11.1211 0.25 12.9492 0.25C14.8281 0.25 16.4531 1.21484 17.418 2.58594ZM9.34375 4.51562L8.68359 4.3125C7.41406 3.90625 5.94141 4.21094 4.92578 5.22656C3.91016 6.24219 3.60547 7.71484 4.01172 8.98438L4.21484 9.64453L3.60547 9.94922C2.38672 10.5586 1.625 11.8281 1.625 13.25C1.625 14.7227 2.38672 15.9414 3.60547 16.6016L4.21484 16.9062L4.01172 17.5664C3.60547 18.8359 3.91016 20.3086 4.92578 21.3242C5.94141 22.3398 7.41406 22.6445 8.68359 22.2383L9.34375 22.0352L9.64844 22.6445C10.3086 23.8633 11.5273 24.625 13 24.625C14.4219 24.625 15.6406 23.8633 16.3008 22.6445L16.6055 22.0352L17.2656 22.2383C18.5352 22.6445 20.0078 22.3398 21.0234 21.3242C22.0391 20.3086 22.3438 18.8359 21.9375 17.5664L21.7344 16.9062L22.3438 16.6016C23.5625 15.9414 24.375 14.7227 24.375 13.25C24.375 11.8281 23.5625 10.5586 22.3438 9.94922L21.7344 9.64453L21.9375 8.98438C22.3438 7.71484 22.0391 6.24219 21.0234 5.22656C20.0078 4.21094 18.5352 3.90625 17.2656 4.3125L16.6055 4.51562L16.3008 3.90625C15.6406 2.6875 14.4219 1.875 13 1.875C11.5273 1.875 10.3086 2.6875 9.64844 3.90625L9.34375 4.51562Z"
                    fill="#CBC0EA"
                  />
                </svg>
                <h3 className="mt-3 mb-4 font-500-26 fan-head4">
                  Simple yet secure verification
                </h3>
                <p className="font-inter-300-15">
                  Our stringent but simple verification process ensures no
                  impersonators—fans know they’re interacting with the real you.
                </p>
              </div>
              <div className="column-3 position-relative">
                <svg
                  width="32"
                  height="27"
                  viewBox="0 0 32 27"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.6875 6.34375C20.1445 6.39453 20.5 6.69922 20.6016 7.15625C20.7539 7.5625 20.6523 8.01953 20.3477 8.32422L18.7734 9.79688L19.1797 11.9297C19.2305 12.3867 19.0781 12.793 18.7227 13.0469C18.5195 13.1992 18.2656 13.25 18.0117 13.25C17.8594 13.25 17.6562 13.25 17.5039 13.1484L15.5742 12.1328L13.6953 13.1484C13.2891 13.3516 12.832 13.3008 12.4766 13.0469C12.1211 12.793 11.9688 12.3867 12.0195 11.9297L12.4258 9.79688L10.8516 8.32422C10.5469 8.01953 10.4453 7.5625 10.5977 7.15625C10.6992 6.69922 11.0547 6.44531 11.5117 6.34375L13.6445 6.03906L14.5586 4.10938C14.9648 3.34766 16.2344 3.34766 16.6406 4.10938L17.5547 6.03906L19.6875 6.34375ZM17.0469 9.23828L18.4688 7.81641L16.4883 7.5625L15.625 5.73438L14.7109 7.5625L12.7305 7.81641L14.1523 9.23828L13.7969 11.2188L15.5742 10.3047L17.4023 11.2188L17.0469 9.23828ZM30.0469 4.16016C30.0977 4.36328 31.1133 9.44141 27.9141 14.1133C25.7812 17.2617 22.3281 19.3945 17.6055 20.5625C16.8945 20.7656 16.3867 21.375 16.3867 22.1367V24.625H21.2617C21.7188 24.625 22.0234 25.0312 22.0234 25.4375C22.0234 25.8945 21.668 26.25 21.2617 26.25H9.9375C9.48047 26.25 9.07422 25.8945 9.07422 25.4375C9.07422 25.0312 9.48047 24.625 9.9375 24.625H14.7617V22.1367C14.7617 21.375 14.2539 20.7148 13.543 20.5625C8.82031 19.3945 5.36719 17.2617 3.28516 14.1133C0.0859375 9.44141 1.10156 4.36328 1.15234 4.16016C1.25391 3.80469 1.55859 3.5 1.96484 3.5H7.5C7.5 3.19531 7.5 2.89062 7.5 2.63672C7.5 1.31641 8.61719 0.25 9.9375 0.25H21.2617C22.582 0.25 23.6992 1.31641 23.6992 2.63672C23.6992 2.89062 23.6992 3.19531 23.6992 3.5H29.2344C29.6406 3.5 29.9453 3.80469 30.0469 4.16016ZM4.60547 13.25C6.12891 15.4844 8.51562 17.1602 11.6133 18.2773C8.51562 14.7227 7.65234 9.08594 7.5 5.125H2.67578C2.52344 6.54688 2.47266 10.0508 4.60547 13.25ZM15.625 19.293C21.7695 16.5508 22.1758 6.80078 22.0742 2.6875C22.0742 2.23047 21.7188 1.875 21.2617 1.875H9.9375C9.48047 1.875 9.125 2.23047 9.125 2.6875C9.02344 6.80078 9.42969 16.5508 15.625 19.293ZM26.5938 13.25C28.7266 10.0508 28.6758 6.54688 28.5234 5.125H23.6992C23.5469 9.08594 22.6836 14.7227 19.5859 18.2773C22.6836 17.1602 25.0703 15.4844 26.5938 13.25Z"
                    fill="#CBC0EA"
                  />
                </svg>
                <h3 className="mt-3 mb-4 font-500-26 fan-head4">
                  How auctions work
                </h3>
                <ul className="px-3">
                  <li className="font-inter-300-15 mb-2">
                    Fans submit blind bids—no one sees the amounts.
                  </li>
                  <li className="font-inter-300-15 mb-2">
                    Highest bid at auction close wins the Fan1 membership.
                  </li>
                  <li className="font-inter-300-15">
                    You set a minimum price to make it worth your while.
                  </li>
                </ul>
              </div>
              <div className="column-3 position-relative">
                <svg
                  width="27"
                  height="27"
                  viewBox="0 0 27 27"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.4844 13.8594C20.4492 13.9609 20.8047 15.1289 20.1445 15.8398L16.2852 19.5977L17.1992 24.9297C17.25 25.2344 17.1484 25.5898 16.8945 25.8438C16.6914 26.0977 16.3867 26.25 16.0312 26.25C15.8281 26.25 15.625 26.1992 15.4727 26.1484L10.75 23.6094L5.97656 26.1484C5.77344 26.25 5.62109 26.25 5.41797 26.25C5.0625 26.25 4.75781 26.0977 4.55469 25.8438C4.35156 25.5898 4.25 25.2344 4.30078 24.9297L5.16406 19.5977L1.35547 15.8398C0.644531 15.1797 1 13.9609 1.96484 13.8594L7.29688 13.0469L9.68359 8.22266C9.88672 7.81641 10.293 7.5625 10.6992 7.5625C11.1562 7.5625 11.5625 7.81641 11.7656 8.22266L14.1523 13.0469L19.4844 13.8594ZM14.5078 19.0391L18.3164 15.332L13.0859 14.5703L10.75 9.79688L8.36328 14.5703L3.13281 15.332L6.89062 19.0391L6.02734 24.2695L10.6992 21.7812L15.4219 24.2695L14.5078 19.0391ZM14 5.9375C13.543 5.9375 13.1875 5.58203 13.1875 5.125C13.1875 4.71875 13.543 4.3125 14 4.36328L17.25 4.3125V1.0625C17.25 0.65625 17.6055 0.25 18.0625 0.25C18.4688 0.25 18.875 0.65625 18.875 1.0625V4.3125L22.125 4.36328C22.5312 4.36328 22.9375 4.71875 22.9375 5.125C22.9375 5.58203 22.5312 5.9375 22.125 5.9375H18.875V9.1875C18.875 9.64453 18.4688 10 18.0625 10C17.6055 10 17.25 9.64453 17.25 9.1875V5.9375H14ZM26.1875 10.8125C26.5938 10.8125 27 11.2188 27 11.6758C27 12.082 26.5938 12.4375 26.1875 12.4375H24.5625V14.0625C24.5625 14.5195 24.1562 14.9258 23.75 14.9258C23.293 14.9258 22.9375 14.5195 22.9375 14.0625V12.4375H21.3125C20.8555 12.4375 20.5 12.082 20.5 11.6758C20.5 11.2188 20.8555 10.8125 21.3125 10.8125H22.9375V9.1875C22.9375 8.78125 23.3438 8.42578 23.75 8.42578C24.1562 8.42578 24.5625 8.78125 24.5625 9.1875V10.8125H26.1875Z"
                    fill="#CBC0EA"
                  />
                </svg>
                <h3 className="mt-3 mb-4 font-500-26 fan-head4">
                  Rankings & visibility
                </h3>
                <ul className="px-3">
                  <li className="font-inter-300-15 mb-2">
                    Fan1 auctions update global rankings.
                  </li>
                  <li className="font-inter-300-15 mb-2">
                    Your highest Fan1 price determines your position on the
                    leaderboard.
                  </li>
                  <li className="font-inter-300-15 mb-2">
                    Public figure and fan are both displayed on rankings,
                    generating buzz and exclusivity.
                  </li>
                </ul>
              </div>
              <div className="column-3 position-relative">
                <svg
                  width="30"
                  height="25"
                  viewBox="0 0 30 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.5 12.25C19.5 15.2461 17.418 17.9375 14.625 17.9375C11.7812 17.9375 9.75 15.2461 9.75 12.25C9.75 9.25391 11.7812 6.5625 14.625 6.5625C17.418 6.5625 19.5 9.25391 19.5 12.25ZM14.625 16.3125C16.25 16.3125 17.875 14.6367 17.875 12.25C17.875 9.86328 16.25 8.1875 14.625 8.1875C12.9492 8.1875 11.375 9.86328 11.375 12.25C11.375 14.6367 12.9492 16.3125 14.625 16.3125ZM0 20.7305V4.98828C0 3.76953 1.26953 2.95703 2.4375 3.3125C6.5 4.37891 10.5625 3.36328 14.625 2.34766C19.043 1.23047 23.4609 0.0625 27.8789 1.73828C28.6914 2.04297 29.25 2.90625 29.25 3.82031V19.5625C29.25 20.7812 27.9297 21.5938 26.7617 21.2383C22.6992 20.1719 18.6367 21.1875 14.625 22.2031C10.1562 23.3203 5.73828 24.4883 1.32031 22.8125C0.507812 22.5078 0 21.6445 0 20.7305ZM4.875 5.34375C3.91016 5.29297 2.94531 5.14062 2.03125 4.83594C1.92969 4.83594 1.77734 4.83594 1.67578 4.9375C1.625 4.9375 1.625 4.98828 1.57422 4.98828H1.625V8.59375C3.40234 8.59375 4.875 7.17188 4.875 5.34375ZM1.625 18.3438V20.7305C1.625 21.0859 1.77734 21.2383 1.92969 21.2891C2.89453 21.6445 3.85938 21.8477 4.875 21.9492V21.5938C4.875 19.8164 3.40234 18.3438 1.625 18.3438ZM1.625 16.7188C4.31641 16.7188 6.5 18.9023 6.5 21.5938V22C8.73438 21.9492 11.1211 21.4414 13.6602 20.7812C13.8633 20.7305 14.0664 20.6797 14.3203 20.6289C16.9609 19.918 19.8047 19.207 22.75 19.1562C22.75 16.4648 24.9336 14.2812 27.625 14.2812V7.78125C24.8828 7.78125 22.75 5.59766 22.75 2.90625V2.55078C20.4648 2.60156 18.0781 3.10938 15.5391 3.76953C15.3359 3.82031 15.1328 3.87109 14.8789 3.92188C12.2383 4.63281 9.39453 5.34375 6.44922 5.39453C6.44922 8.08594 4.26562 10.2188 1.625 10.2188V16.7188ZM27.5234 19.6133C27.5742 19.6133 27.5742 19.5625 27.625 19.5625V15.9062C25.7969 15.9062 24.375 17.3789 24.375 19.1562V19.207C25.2891 19.2578 26.2539 19.4102 27.168 19.6641C27.2695 19.7148 27.4219 19.7148 27.5234 19.6133ZM27.625 6.15625V3.82031C27.625 3.46484 27.4219 3.3125 27.2695 3.26172C26.3047 2.90625 25.3398 2.70312 24.375 2.60156V2.90625C24.375 4.73438 25.7969 6.15625 27.625 6.15625Z"
                    fill="#CBC0EA"
                  />
                </svg>
                <h3 className="mt-3 mb-4 font-500-26 fan-head4">
                  Payments & payouts
                </h3>
                <ul className="px-3">
                  <li className="font-inter-300-15 mb-2">
                    Fan1 handles payment processing automatically.
                  </li>
                  <li className="font-inter-300-15 mb-2">
                    You receive 70% of the final bid amount.
                  </li>
                  <li className="font-inter-300-15 mb-2">
                    Optional: Donate a percentage to your charity directly from
                    your payout.
                  </li>
                </ul>
              </div>
            </div>
            <div className="static-ellipse-right"></div>
          </div>

          <div className="d-block d-md-none tile-block p-0">
            <div className="image-container mx-auto bg-midnight">
              <img src={fam2} alt={""} className="image-style" />

              <div className="d-flex flex-column justify-content-center align-items-center align-self-stretch">
                <div className="w-100 d-flex flex-column justify-content-between h-100 data">
                  <div className="d-block">
                    <div className="heading">A secure & trusted platform</div>
                    <h3 className="text-light-purple mb-5 font-500-26 font-inter fan-head4">
                      Rest easy, your privacy & safety is our number 1 priority
                    </h3>
                    <h3 className="font-500-26 fan-head4">Key Features: </h3>
                    <ul className="px-4">
                      <li>
                        <div className="pb-2">
                          <span className="font-inter-700-15">
                            No location data
                          </span>
                          <span className="font-inter-300-15">
                            {" "}
                            is ever gathered or shared.
                          </span>
                        </div>
                      </li>
                      <li>
                        <div className="pb-2">
                          <span className="font-inter-700-15">
                            Secure authentication and payouts
                          </span>
                          <span className="font-inter-300-15">
                            {" "}
                            via industry leaders
                          </span>
                          <span className="font-inter-700-15">
                            {" "}
                            Auth0 & Stripe.
                          </span>
                        </div>
                      </li>
                      <li>
                        <div className="pb-2">
                          <span className="font-inter-300-15">
                            Every Fan1 agrees to a{" "}
                          </span>
                          <span className="font-inter-700-15">
                            strict Code of Conduct{" "}
                          </span>
                          <span className="font-inter-300-15">
                            —violators are warned, muted, or banned.
                          </span>
                        </div>
                      </li>
                      <li>
                        <div>
                          <span className="font-inter-300-15">
                            Try it out.{" "}
                          </span>
                          <span className="font-inter-700-15">
                            {" "}
                            Easily pause or cancel
                          </span>
                          <span className="font-inter-300-15">
                            {" "}
                            before any auction.
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-none d-md-flex fam-div-2 bg-midnight mt-80 position-relative fam5">
            <div className="col-7 famcol">
              <h2 className="font-500-36 fan-head1">
                A secure & trusted platform
              </h2>
              <h3 className="text-light-purple mb-5 font-500-26 font-inter fan-head4">
                Rest easy, your privacy & safety is our number 1 priority
              </h3>
              <h3 className="font-500-26 fan-head4">Key Features: </h3>
              <ul className="px-4">
                <li>
                  <div className="pb-2">
                    <span className="font-inter-700-15">No location data</span>
                    <span className="font-inter-300-15">
                      {" "}
                      is ever gathered or shared.
                    </span>
                  </div>
                </li>
                <li>
                  <div className="pb-2">
                    <span className="font-inter-700-15">
                      Secure authentication and payouts
                    </span>
                    <span className="font-inter-300-15">
                      {" "}
                      via industry leaders
                    </span>
                    <span className="font-inter-700-15"> Auth0 & Stripe.</span>
                  </div>
                </li>
                <li>
                  <div className="pb-2">
                    <span className="font-inter-300-15">
                      Every Fan1 agrees to a{" "}
                    </span>
                    <span className="font-inter-700-15">
                      strict Code of Conduct{" "}
                    </span>
                    <span className="font-inter-300-15">
                      —violators are warned, muted, or banned.
                    </span>
                  </div>
                </li>
                <li>
                  <div>
                    <span className="font-inter-300-15">Try it out. </span>
                    <span className="font-inter-700-15">
                      {" "}
                      Easily pause or cancel
                    </span>
                    <span className="font-inter-300-15">
                      {" "}
                      before any auction.
                    </span>
                  </div>
                </li>
              </ul>
            </div>

            <div className="col-5 ps-1 m-0">
              <img src={fam2} className="h-100 w-100 fam2" alt="" />
            </div>
          </div>

          <div className="fam-div-3 mt-80 bg-midnight position-relative">
            <h2 className="font-500-36">Register & offer a membership</h2>
            <div className="fam-row register mt-3">
              <div className="column-3 position-relative">
                <svg
                  width="32"
                  height="36"
                  viewBox="0 0 32 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="32" height="36" rx="16" fill="#CBC0EA" />
                  <path
                    d="M20.0542 26H15.1582V14.288H14.9182L11.0542 17.12V12.368L15.8062 8.816H20.0542V26Z"
                    fill="#070115"
                  />
                </svg>
                <h3 className="mt-3 mb-4 font-500-26">
                  Register & get verified
                </h3>
                <p className="font-inter-300-15">
                  Only verified musicians, actors, models, athletes, influencers
                  and other public figures can join. We ensure a trusted
                  experience.
                </p>
              </div>
              <div className="column-3 position-relative">
                <svg
                  width="32"
                  height="36"
                  viewBox="0 0 32 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="32" height="36" rx="16" fill="#CBC0EA" />
                  <path
                    d="M22.4697 26H9.19769V23.12L16.3497 17.192C17.5257 16.184 18.3417 15.488 18.3417 14.456C18.3417 13.28 17.4537 12.44 16.2057 12.44C14.7897 12.44 13.7337 13.544 13.6857 15.392H9.26969C9.10169 11.384 12.0777 8.48 16.3017 8.48C20.1177 8.48 22.9017 10.784 22.9257 14C22.9257 16.112 21.5577 17.672 19.6617 19.184L15.9897 22.112V22.352H22.4697V26Z"
                    fill="#070115"
                  />
                </svg>
                <h3 className="mt-3 mb-4 font-500-26">
                  Schedule your first auction
                </h3>
                <p className="font-inter-300-15">
                  Pick your drop day, approve your profile, and share your
                  auction link on social media for a boost.
                </p>
              </div>
              <div className="column-3 position-relative">
                <svg
                  width="32"
                  height="36"
                  viewBox="0 0 32 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="32" height="36" rx="16" fill="#CBC0EA" />
                  <path
                    d="M16.0377 26.36C12.0297 26.36 9.02969 23.552 8.88569 19.736H13.4457C13.4457 21.344 14.5497 22.544 15.9897 22.544C17.3817 22.544 18.3657 21.536 18.3657 20.216C18.3657 18.872 17.3577 17.888 15.9897 17.888C15.5097 17.888 14.9577 18.008 14.6457 18.176L13.6377 15.536L16.5897 12.704V12.464H10.0377V8.816H22.3977V11.648L18.6777 15.248C21.2217 15.776 23.0937 17.984 23.0937 20.624C23.0937 23.96 20.1417 26.36 16.0377 26.36Z"
                    fill="#070115"
                  />
                </svg>
                <h3 className="mt-3 mb-4 font-500-26">Engage on your terms</h3>
                <p className="font-inter-300-15">
                  Your highest bidding fan gets messaging access to you for a
                  limited time—no spamming, no distractions, and no minimum time
                  investment required.
                </p>
              </div>
              <div className="column-3 position-relative">
                <svg
                  width="32"
                  height="36"
                  viewBox="0 0 32 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="32" height="36" rx="16" fill="#CBC0EA" />
                  <path
                    d="M21.4461 26H16.3581V22.544H8.31813V19.928L14.3901 8.816H21.4461V18.92H23.3661V22.544H21.4461V26ZM16.1181 12.728L12.8541 18.92H16.3581V12.728H16.1181Z"
                    fill="#070115"
                  />
                </svg>
                <h3 className="mt-3 mb-4 font-500-26">Get paid, repeat</h3>
                <p className="font-inter-300-15">
                  Fan1 handles transactions so you can focus on meaningful
                  connections.{" "}
                </p>
              </div>
            </div>
            <div className="static-ellipse-left"></div>
          </div>

          <div className="mt-80">
            <h2 className="font-500-36">Ready to get started?</h2>
            <div className="tile-block p-0">
              <Tile
                src={fam3}
                alt="tile image"
                title="Register & offer a membership"
                classname="bg-midnight"
                btnLabel="Start Registration"
                btnClass="fan-button"
                onClick={() => window.open("https://fan1.us/register", "_blank", "noopener,noreferrer")}
              />
              <Tile
                src={fam4}
                alt="tile image2"
                title="See the current stack rank"
                classname="bg-midnight"
                btnLabel="View Global Rankings"
                btnClass="fan-button"
                onClick={() => navigate("/rankings")}
              />
              <Tile
                src={fam5}
                alt="tile image3"
                title="Want to learn more?"
                classname="bg-midnight"
                btnLabel="How Fan1 Works"
                btnClass="fan-button"
                onClick={() => navigate("/learn")}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FamousPage;
